import React from 'react';
import AgentDashboard from './AgentDashboard';

const UniFirstDocsDashboard: React.FC = () => {
  const agentConfig = {
    id: 'unifirst_docs',
    displayName: 'UniFirst Docs',
    icon: '/assets/logos/aldounifirstdocs.png',
    color: '#8b5cf6',
    description: 'UniFirst internal documentation assistant',
    hasTestResults: false
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default UniFirstDocsDashboard;


